import React from 'react';

// DC-001 (2026-05-27): the top-level `/athena/integrations` route was
// retired — only the per-project tab (`ProjectIntegrationsTab`) is
// reachable. The empty fragment keeps the feature-folder convention
// (every feature exports `routes.jsx`) without resurrecting a dead URL.
export const integrationsRoutes = <></>;
